<template>
  <div id="zoomPhotos" v-show="active">
    <div class="container">
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
            <div id="zoom-header">
              <button class="close-zoom" @click="close">
                <i class="fa fa-times"></i>
              </button>
              <ul>
                <li v-if="currentPhoto.free()">
                  <a class="download-free" :title="$t('photo.download')" @click="download">
                    <i class="fa fa-arrow-down"></i>
                  </a>
                </li>
                <li v-if="currentPhoto.free() && socialShare">
                  <a class="share-social-media" :title="$t('photo.share')" @click="share">
                    <i class="fa fa-share-alt"></i>
                  </a>
                </li>
                <li v-if="!currentPhoto.free()">
                  <a class="download-free" :title="$t('photo.addToCart')" @click="addToCart">
                    <i class="fa fa fa-shopping-cart"></i>
                  </a>
                </li>
                <li>
                  <a class="favorite" :title="$t('photo.rekognition')" @click="rekognition">
                    <img src="/rekognition.png">
                  </a>
                </li>
                <li v-if="currentPhoto.selected">
                  <a class="favorite" :title="$t('photo.removeFromFavorites')" @click="remove">
                    <i class="fa fa-heart"></i>
                  </a>
                </li>
                <li v-else>
                  <a class="favorite" :title="$t('photo.addToFavorites')" @click="add">
                    <i class="fa fa-heart-o"></i>
                  </a>
                </li>
              </ul>
              <SocialMedia :activeShareMedia="activeShare" :photo="currentPhoto" full="true"/>
            </div>
            <div id="zoom-photos" class="carousel-inner">
              <div class="carousel-item"
                   v-for="(photo, index) in photos"
                   :key="index"
                   v-bind:class="{active: index == activeIndex}">
                <img :src="photo.zoom" class="d-block" />
              </div>
            </div>
            <div class="total-zoom">
              {{totalLegend}}
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev" ref="prev">
              <i class="fa fa-arrow-circle-o-left"></i>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next" ref="next">
              <i class="fa fa-arrow-circle-o-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Photo from '../models/Photo';
import SocialMedia from "./SocialMedia";
import DownloadMixin from '../mixins/DownloadMixin';

export default {
  name: "PhotoZoom",
  mixins: [
    DownloadMixin
  ],
  components: {
    SocialMedia
  },
  props:  {
    zoomPhotos: [],
    photo: {},
    event: {
      type: Object,
      default: null
    },
    competitor: {
      type: Object,
      default: null
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPhoto: new Photo(),
      activeShare: false,
      carousel: {},
      photos: [],
      currentIndex: 0,
    }
  },
  mounted() {
    const _this = this,
        carousel = document.getElementById('carouselExampleControls')

    this.carousel = new bootstrap.Carousel(carousel, {
      interval: false,
      wrap: true,
      pause: true
    })

    carousel.addEventListener('slide.bs.carousel', function(slide) {
      _this.setPhoto(slide.to)
    })

    document.addEventListener('keydown', function(e) {
      switch (e.keyCode) {
        case 37:
          _this.$refs.prev.click()
          break;
        case 39:
          _this.$refs.next.click()
          break;
      }
    })
  },
  watch: {
    active(value) {
      if(value) {
        this.currentIndex = this.activeIndex
      }
    },
    zoomPhotos(photos) {
      this.photos = photos.map(photo => new Photo(photo))

      if(photos.length == 0) {
        this.currentIndex = 0
      } else {
        this.setPhoto(this.activeIndex)
      }
    }
  },
  methods: {
    ...mapActions('ShoppingCartStore', ['addShoppingCartItem']),

    async addToCart() {
      const params = { event_id: this.currentPhoto.event_id, photo_id: this.currentPhoto.id };
      this.$alertify.success(this.$t("checkout.addedItem"))
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params);
    },
    async download() {
      if(this.requireSignIn) {
        this.close();
        this.openSignin();
      } else {
        await this.downloadPhoto(this.currentPhoto);
      }
    },
    close() {
      this.$emit("closeZoom", false)
    },
    setPhoto(index) {
      this.currentIndex = index
      this.currentPhoto = this.photos[this.currentIndex]
      this.activeShare = false
    },
    add() {
      this.currentPhoto.addFavorite(this.parameters).then(() => {
        this.$root.$emit('addFavoritePhoto', this.currentPhoto)
      }).catch((error) => {
        this.selected = false
      })
    },
    remove() {
      this.$root.$emit('removeFavoritePhoto', this.currentPhoto)
      this.currentPhoto.removeFavorite(this.parameters).then(() => {})
          .catch((error) => {
            console.log(error)
          })
    },
    share() {
      if(this.requireSignIn) {
        this.close();
        this.openSignin();
      } else {
        this.activeShare = true;
      }
    },
    rekognition() {
      let competitor = null
      this.$emit("setLoader", true)

      if(this.competitor && this.competitor.number) {
        competitor = this.competitor.number
      }

      this.currentPhoto.rekognition({competitor: competitor}).then((object) => {
        this.$root.$emit('addRekognitionPhotos', object.response.data.photos)
        this.close()
        this.$emit("setLoader", false)
      }).catch((error) => {
        console.log(error)
        this.$emit("setLoader", false)
      })
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    parameters() {
      return {
        competitor: this.competitorId
      };
    },
    competitorId() {
      return (this.competitor == null) ? null : this.competitor.number;
    },
    total() {
      return this.photos.length
    },
    numberPhoto() {
      return this.currentIndex + 1
    },
    totalLegend() {
      return `${this.numberPhoto} / ${this.total}`
    },
    free() {
      return this.currentPhoto.free()
    },
    socialShare() {
      return this.event.share_social_media;
    },
  }
}
</script>

<style lang="scss" scoped>
$color: gray;

#zoomPhotos {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.97);
  z-index: 9999;
  overflow-x: hidden;
  overflow-y: auto;
  inset: 0px;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

#zoom-header {
  height: 12vh;
  position: relative;
  ul {
    position: absolute;
    bottom: 0;
    padding: 0;

    li {
      padding-right: 2rem;
      display: inline;
      a {
        color: $color;
        font-size: 24px;
        cursor: pointer;

        img {
          width: 26px !important;
          height: 26px !important;
          vertical-align: text-top;
          margin-top: 1px;
        }
      }
    }
  }
}

#zoom-photos {
  height: 77vh;

  .carousel-item {
    height: 100%;
  }
  img {
    margin: auto;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
    /*
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    */
  }
}

.carousel-control-next, .carousel-control-prev {
  top: 71px;
  width: 10%;
  top: 29%;
  font-size: 32px;
  height: 450px;

  &:hover, &:focus {
    color: #000;
  }
}

.total-zoom {
  text-align: center;
  line-height: 50px;
  color: $color;
  font-size: 18px;
}

.close-zoom {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 5px;
  font-size: 21px;
  color: $color;
  width: 32px;
  height: 32px;
  z-index: 9999;
}

@media screen and (max-width: 600px) {
  #zoom-photos {
    height: 40vh;
  }
  .carousel-control-next, .carousel-control-prev {
    top: 30%;
    bottom: 30%;
  }
}
.carousel-inner {
  touch-action: pan-y !important;
}

img {
  user-select: auto;
}
.carousel-control-prev,
.carousel-control-next {
  pointer-events: none;
}

.carousel-control-prev i,
.carousel-control-next i {
  pointer-events: all;
}
#zoom-photos {
  touch-action: manipulation;
}

.carousel-inner img {
  touch-action: none;
}
</style>